
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CTA() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="relative py-16 md:py-28 px-5 md:px-8 overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ae60c8b7ef849b90d7bb88e960dcf501.jpg"
          alt="건강한 아침 스피루리나 스무디와 약손콩"
          title="자연담은 건강한 라이프스타일"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
      </div>

      <div ref={ref} className="relative z-10 max-w-3xl mx-auto text-center">
        <div className={isVisible ? 'animate-fade-in-up' : 'opacity-0'}>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3 md:mb-4" style={{ fontFamily: 'Noto Serif KR, serif' }}>
            지금 시작하세요
          </h2>
          <p className="text-sm md:text-lg text-white/70 mb-2 md:mb-3">
            첫 구매 고객 <strong className="text-emerald-300">20% 할인</strong> 혜택
          </p>
          <p className="text-xs md:text-sm text-white/50 mb-8 md:mb-10">
            3만원 이상 구매 시 무료배송 · 100% 만족 보장
          </p>
          <a
            href="#products"
            onClick={(e) => {
              e.preventDefault();
              const target = document.getElementById('products');
              if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="inline-flex items-center gap-2 px-8 md:px-10 py-3 md:py-4 bg-emerald-600 text-white rounded-full text-sm font-semibold hover:bg-emerald-700 hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            구매하기
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
